/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\index.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Tuesday June 6th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday, 7th September 2023 06:45:55
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import {createRoot} from "react-dom/client";
import "index.css";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
// Import for to the Global THEME
import Theme from "Theme/Theme";
// Import for the router
import { RouterProvider } from "react-router-dom";
import Router from "Router/Router";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

function AppComponent() {

  return (
    <Theme pendingComponent={LoadingScreen}>
      <RouterProvider router={Router()}/>
    </Theme>
  );
};

const root = createRoot(document.getElementById('root')!);

root.render(
  // <React.StrictMode>
    <AppComponent />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
